export const PARTNER_NONE = '__none__';
